import { React, useEffect, useState, useRef } from 'react'
import { useNavigate } from "react-router-dom";
import { Button, Tabs, Alert  } from "flowbite-react";
import { HiAdjustments, HiClipboardList, HiUserCircle  } from "react-icons/hi";
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow } from "flowbite-react";
import { PencilSquareIcon, ArrowUpTrayIcon, ListBulletIcon } from '@heroicons/react/24/outline'
import { MdDashboard, MdOutlineAttachFile  } from "react-icons/md";
import templateTab from '../../css/template_tab';
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const File = ({solutionId, onClose, solutionName}) => {

  const [descriptionNull, setDescriptionNull] = useState(true);
  const [fileId, setFileId] = useState("");
  const instaladorRef  = useRef(null);
  const documentoRef = useRef(null);
  const navigate = useNavigate();
  const [solutionIdProp, setSolutionIdProp] = useState("");
  const [solutionNameInput, setSolutionNameInput] = useState(solutionName);
  const [prefixFile, setPrefixFile] = useState("");
  const [disableButton, setDisableButton] = useState(false);
      const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    folderName: "documentacion",
    solutionidhdn: solutionId,
    prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9),
    solutionTitleHdn : "",
    titulo: "",
    descripcion: "",
    version: "",
    responsable: "",
    instalador: "",
    documento: "",
    pageIni: "1",
  });
    
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("formData.solutionTitleHdn",formData.solutionTitleHdn);
    let inputValue = value;
    if(name=="version"){
      formData.titulo = `${formData.solutionTitleHdn} - ${inputValue}`;
      //setFormData({ ...formData, "titulo" : inputValue });
    }
    setFormData({ ...formData, [name]: inputValue });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const handleCancel = () => {
    setFormData({
      titulo: solutionName,
      solutionTitleHdn: solutionName,
      solutionidhdn: solutionId,
      prefixFile: Date.now() + "-" + Math.round(Math.random() * 1e9),
      folderName: "documentacion",
      version: "",
      responsable: ""
    });
    
    if (instaladorRef.current) instaladorRef.current.value = null;
    if (documentoRef.current) documentoRef.current.value = null;

  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      setDisableButton(true);
      //formData.titulo = `${solutionNameInput}  - ${formData.version}`;
      const response = await axios.post(
        `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/file/create`,formData,
        {
          withCredentials: true,
          headers: {
              "Content-Type": "multipart/form-data",
          },
        });
      if(response.data.status === "OK"){
        alert("Archivo procesado correctamente!");
        setFileId(response.data.file.id);
        navigate(`./solucion/${solutionIdProp}/view?instalador=${response.data.file.id}`);
        handleCancel();
      }
      setDisableButton(false);
    } catch (error) {
      setDisableButton(false);
    } finally{
      setIsLoading(false);
    }
  }


  useEffect(()=>{
    
    if(solutionId){
      setSolutionIdProp(solutionId);
      setFormData({ ...formData, "solutionidhdn" : solutionId });
    }

    setPrefixFile(Date.now() + "-" + Math.round(Math.random() * 1e9));
    
    if(solutionName){
      setSolutionNameInput(solutionName);
      formData.solutionTitleHdn = solutionName;
      formData.titulo = solutionName;
      console.log("name:",solutionName);
      setFormData({ ...formData, "solutionTitleHdn" : solutionName });
      console.log("solutionTitleHdn:",formData.solutionTitleHdn);
    }
  },[solutionId, solutionName]);

  return (
    <>
      {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
      <div>

        <input type="hidden" name="solutionidhdn" onChange={handleInputChange} value={solutionId} />
        <input type="hidden" name="folderName" onChange={handleInputChange} value={formData.folderName}/>
        <input type="hidden" name="prefixFile" onChange={handleInputChange} value={formData.prefixFile} />
        <input type="hidden" name="solutionTitleHdn" onChange={handleInputChange} value={solutionName} />
        
        <div className='lg:flex'>
          <div className='flex-col lg:w-1/2 w-full'>
            <div >
              <div>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Título</label>
                <input
                  type="text"
                  name="titulo"
                  value={formData.titulo}
                  readOnly={true}
                  onChange={handleInputChange}
                  aria-describedby="helper-text-explanation" 
                  className="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                
                />
              </div>
            </div>
            {
              (!descriptionNull) &&
              <div>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Descripción</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleInputChange}
                  aria-describedby="helper-text-explanation" 
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                
                ></textarea>
              </div>

            }
            <div className='grid lg:grid-cols-2'>
              <div className='p-1'>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Versión</label>
                <input
                  type="text"
                  name="version"
                  value={formData.version}
                  onChange={handleInputChange}
                  aria-describedby="helper-text-explanation" 
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                  
                />
              </div>
              <div className='p-1'>
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Responsable</label>
                <input
                  type="text"
                  name="responsable"
                  value={formData.responsable}
                  onChange={handleInputChange}
                  aria-describedby="helper-text-explanation" 
                className="uppercase bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                />
              </div>
            </div>
            
          </div>
          <div className='flex-col lg:w-1/2 w-full px-4'>
            <div>
              <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Instalador</label>
              <input
                type="file"
                name="instalador"
                accept=".rar,.zip,.pdf,.docx"
                onChange={handleFileChange}
                ref={instaladorRef}
                aria-describedby="helper-text-explanation" 
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
              
              />
            </div>

            <div>
              <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Doc. Mejora</label>
              <input
                type="file"
                name="documento"
                accept=".rar,.zip,.pdf,.docx"
                ref={documentoRef} 
                onChange={handleFileChange}
                aria-describedby="helper-text-explanation" 
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-1  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
              
              />
            </div>
            
          </div>
        </div>
        <div className="flex justify-between mt-4">
            <button
              type="button"
              onClick={handleCancel}
              className="bg-gray-200  px-4 py-2 rounded"
            >
              Limpiar
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={disableButton}
              className="bg-green-400  px-4 py-2 rounded"
            >
              Guardar instalador
            </button>
        </div>  
      </div>
    </>
  )
}

export default File


/*
  <div>
      <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Pagina inicial</label>
      <input
        type="text"
        name="pageIni"
        value={formData.pageIni}
        onChange={handleInputChange}
        aria-describedby="helper-text-explanation" 
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full px-1  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
        
      />
    </div>

    */